import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { JVInput } from "../../shared/JVInput";
import { JVDate } from "../../shared/JVDate";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { useEffect, useState } from "react";
import { IBranchMastDropdown, IClientCompanyDropdown, ICompanyMastDropdown, IUsersDropdown } from "../../models/IDropdown";
import { Fetch } from "../../shared/Fetch";
import { Button } from "primereact/button";
import { EmptyFilter } from "./Table";
import { PaymentTerm } from "../../models/ConsultantMast";
import { BillingCycle } from "../showPurchaseOrder/GeneratePO";

interface IProps {
    invoiceFilter: InvoiceTrackingFilter,
    setReqFilter: (invoiceFilter: InvoiceTrackingFilter) => void,
    singleData?: any,
    toast: any,
    byPO_ID: boolean
};

export interface InvoiceTrackingFilter {
    year?: Date | null,
    month?: Date | null,
    vendor_Company?: IClientCompanyDropdown | null,
    prime_Vendor_Billing_Cycle?: BillingCycle | null,
    invoiceStatus?: number | null,
    paymentStatus?: string | null,
    consultant?: any | string | null,
    subVendor_Company?: string | null,
    fromDate?: Date | null,
    toDate?: Date | null,
    Company?: number | null,
    Branch?: number | null,
    SM?: number | null,
    Recruiter?: number | null,
    dueDateFrom?: Date | null,
    dueDateTo?: Date | null,
    invoiceNO?: string | null,
    releaseStatus?: boolean | null
}

const schema = yup.object({
    year: yup.date().nullable(),
    month: yup.date().nullable(),
    client: yup.string().nullable(),
    prime_Vendor_Billing_Cycle: yup.number().nullable(),
    invoiceStatus: yup.string().nullable(),
    paymentStatus: yup.string().nullable(),
    consultant: yup.object().shape({
        consultant_ID: yup.number().nullable(),
        consultant_Name: yup.string().nullable()
    }).nullable(),
    subVendor_Company: yup.string().nullable(),
    Company: yup.string().nullable(),
    Branch: yup.string().nullable(),
    SM: yup.number().nullable(),
    Recruiter: yup.string().nullable(),
    invoiceNO: yup.string().nullable(),
    releaseStatus: yup.boolean().nullable(),
});

export const Filter = (props: IProps) => {
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();
    const [company, setCompany] = useState<Array<ICompanyMastDropdown>>();
    const [branch, setBranch] = useState<Array<IBranchMastDropdown>>();
    const [sm, setSM] = useState<Array<IUsersDropdown>>();
    const [recruiters, setRecruiters] = useState<Array<IUsersDropdown>>();
    const [consultant, setConsultant] = useState<Array<any>>();

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<InvoiceTrackingFilter>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });
    const onSubmit = (data: InvoiceTrackingFilter) => {
        props.setReqFilter(data);
    };

    const Payment_Status = [
        { name: "-- SELECT --", value: null },
        { name: "Pending", value: "Pending" },
        { name: "Paid", value: "Paid" },
        { name: "Balance", value: "Balance" },
        { name: "Over Payment", value: "Over Payment" },
    ];
    const Invoice_Status = [
        { name: "-- SELECT --", value: null },
        { name: "Not Required", value: "Not Required" },
        { name: "Generated", value: "Generated" },
        { name: "Sent to Client", value: "Sent to Client" },
        { name: "Yet to Generated", value: "Yet to Generated" },
    ];

    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
        }
    }
    const completeMethodClientCompanies = (event: { query: string }) => {
        loadClientCompanies(event.query);
    };

    const loadSm = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        } else if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSM(data);
        }
    }

    const loadBranch = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        const response = await Fetch("Dropdown/filterBranchList", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranch(data);
        }
    }


    const loadCompany = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompany(data);
        }
    }

    const loadRecruiters = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        } else if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersList", "GET", null, `user_Type=recruiter&${queryParameter}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setRecruiters(data);
        }
    };

    const loadConsultant = async (filter: string | null) => {
        const response = await Fetch(`Dropdown/consultantBySeacrhQuery`, "GET", null, `searchQuery=${filter}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            const emptyData = {
                consultant_ID: 0,
                consultant_Name: "-- SELECT --",
            };
            data.unshift(emptyData);
            setConsultant(data);
        }
    };

    const completeMethodConsultant = (event: { query: string }) => {
        loadConsultant(event.query);
    }


    useEffect(() => {
        const subscription = watch((value, { name, type }) => {

            if (name === "Company") {
                if (value.Company != 0 && value.Company != null) {
                    loadSm(0, value.Company, 0);
                    loadBranch(value.Company);
                } else {
                    if (value.Company === 0 && value.Company != null) {
                        loadBranch();
                        loadRecruiters(control._formValues.Branch, value.Company, control._formValues.Team_Name);
                        loadSm(control._formValues.Branch, value.Company, control._formValues.Team_Name);
                    }
                }
            }

            if (name === "Branch") {
                if (value.Branch != 0 && value.Branch != null) {
                    loadSm(value.Branch, 0, 0);
                    loadRecruiters(value.Branch, 0, 0);
                } else {
                    if (value.Branch === 0 && value.Branch != null) {
                        loadRecruiters(value.Branch, control._formValues.Company, control._formValues.Team_Name);
                        loadSm(value.Branch, control._formValues.Company, control._formValues.Team_Name);
                    }
                }
            }


        });

        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        loadSm(0, 0, 0);
        loadBranch();
        loadCompany();
        loadRecruiters(0, 0, 0);
    }, []);


    useEffect(() => {
        reset(props.invoiceFilter);
    }, [props.invoiceFilter]);

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDate column={6} label="From Date" control={control} name="fromDate" />
                <JVDate column={6} label="To Date" control={control} name="toDate" />
                <JVDropdownInput column={6} completeMethod={completeMethodClientCompanies} label="Vendor Company" control={control} name="vendor_Company" options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Client/Company" />
                {/* <JVInput column={6} label="Consultant Name" control={control} name="consultantName" /> */}
                <JVDropdownInput column={6} label="Consultant Name" completeMethod={completeMethodConsultant} control={control} name="consultant" options={consultant} optionLabel="consultant_Name" placeholder="Search " />
                <JVInput column={6} label="Sub Vendor" control={control} name="subVendor_Company" />
                <JVDropdown column={6} label="Company Name " control={control} name="Company" options={company} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company Name" />
                <JVDropdown column={6} label="Branch " control={control} name="Branch" options={branch} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch " />
                <JVDropdown column={6} label="S M" filter control={control} name="SM" options={sm} optionLabel="user_Name" optionValue="login_ID" placeholder="SM" />
                <JVDropdown column={6} label="Recruiter" filter control={control} name="Recruiter" options={recruiters} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Recruiter" />
                <JVDropdown column={6} label="Payment Status" control={control} name="paymentStatus" options={Payment_Status} optionLabel="name" optionValue="value" placeholder="Select Payment Status" />
                <JVDate column={6} label="Due Date From" control={control} name="dueDateFrom" />
                <JVDate column={6} label="Due Date To" control={control} name="dueDateTo" />
                <JVInput column={6} label="Invoice No" control={control} name="invoiceNO" />
                <JVDropdown column={6} label="Release Status" control={control} name="releaseStatus" options={[{ name: "-- Select --", value: null }, { name: "Yes", value: true }, { name: "No", value: false }]} optionLabel="name" optionValue="value" placeholder="Select Release Status" />
                <div style={{ margin: '10px 0', width: '100%' }}></div>
                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset(EmptyFilter) }} type="button"></Button>
                </div>
            </form>
        </>
    );
}